module.exports = __webpack_public_path__ + "img/franchising_help_training3.26fff86a.png";